import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionPrivateCodeConfirmedDialogComponent } from 'app/dialogs/transaction-private-code-confirmed-dialog/transaction-private-code-confirmed-dialog.component';
import { UpdateTransacitonStatus } from 'app/dtos/Transaction/updateTransactionStatus';
import { QuoteCodeService } from 'app/services/models/quote-code.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-offer-private-detail',
  templateUrl: './offer-private-detail.component.html',
  styleUrls: ['./offer-private-detail.component.scss']
})
export class OfferPrivateDetailComponent implements OnInit {
  public transaction: any = {};
  public contentHeader: object;
  isDiscount: boolean = false;
  transactionList: any[] = []
  totalAmount: number | null = null;

  expiry: Date;
  isDisabled: boolean = false;

  constructor(
    private activatedRouter: ActivatedRoute,
    private transactionService: TransactionService,
    private toastrService: ToastrService,
    private quoteCodeService: QuoteCodeService,
    private modalService:NgbModal,
    private router:Router) { }

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'Teklif',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Teklif Müşteri Görüntüleme',
            isLink: false,
          },
        ]
      }
    };
    this.transactionService.event$.subscribe(async result => {
      this.activatedRouter.params.subscribe(async params => {

        await this.getByIdQuoteCode(params['id'])
        if (this.quoteCode != null && this.quoteCode.code == params['code'] && this.quoteCode.isExpired) {
          await this.getByIdTransaction(params['id']);
        } else {
          this.toastrService.info("Bu linkin süresi dolmuştur. Lütfen yetkili ile iletişime geçin ve yeni kod yollasın ve açılan dialog penceresine gelen kodu giriniz.","Kod Sürei dolmuş",{
            timeOut:5000
          })
        }
      });
    });
    this.activatedRouter.params.subscribe(async params => {

      await this.getByIdQuoteCode(params['id'])
      if (this.quoteCode != null && this.quoteCode.code == params['code'] && this.quoteCode.isExpired) {
        await this.getByIdTransaction(params['id']);
      } else {
        this.toastrService.info("Bu linkin süresi dolmuştur. Lütfen yetkili ile iletişime geçin ve yeni kod yollasın ve açılan dialog penceresine gelen kodu giriniz.","Kod Sürei dolmuş",{
          timeOut:5000
        });
        this.openDialog(this.quoteCode.transactionManagementId)
      }
    });
  }

  remainingTime: number = 0;
  timerInterval: any;

   startCountdown(id) {
    const now = new Date(); // Şu anki zaman
    const timeDifference = this.expiry.getTime() - now.getTime(); // Kalan süreyi milisaniye olarak hesapla

    if (timeDifference > 0) {
      this.remainingTime = timeDifference; // Başlangıçta kalan zamanı milisaniye cinsinden ayarla

      this.timerInterval = setInterval(() => {
        this.remainingTime -= 1000; // Her saniye kalan zamanı 1000 milisaniye azalt

        if (this.remainingTime <= 0) {
          clearInterval(this.timerInterval); // Süre dolduğunda sayacı durdur
          this.isDisabled = true; // Sayfadaki her şeyi devre dışı bırak
          this.openDialog(id); // Dialog'u aç
        }
      }, 1000);
    } else {
      this.openDialog(id);
    }
  }

  openDialog(id) {
    const modal = this.modalService.open(TransactionPrivateCodeConfirmedDialogComponent, {
      size: 'sm',
      windowClass: 'modal modal-success'
    });

    modal.result.then((result) => {
      if (result) {
        this.router.navigate(['/admin/offer-private/' + id + '/' + result]);
      }
    }).catch((error) => {
      console.log('Modal dismissed', error);
    });
  }


  quoteCode: any = {};
  async getByIdQuoteCode(transactionId) {
    const data = await this.quoteCodeService.getByIdQuoteCodes(transactionId);
    this.quoteCode = data;
    console.log(this.quoteCode)
    this.expiry = new Date(this.quoteCode.expiry);
    this.startCountdown(this.quoteCode.transactionManagementId);
  }

  async getByIdTransaction(id) {
    const data = await this.transactionService.getByIdTransaction(id);
    this.transaction = data;

    this.transactionList = this.transaction.transactionManagementProducts;
    console.log(this.transaction);
    this.calculateTotalAmount();
  }

  async updateTransactionStatus(id, kindId, status) {
    const updateStatus = new UpdateTransacitonStatus();
    updateStatus.id = id;
    updateStatus.kindId = kindId;
    updateStatus.status = status;
    const response = await this.transactionService.UpdateTransactionStatus(updateStatus);
    if (response.status == true) {
      this.transactionService.sendEvent(true);
      this.toastrService.success(response.message);
    } else {
      this.toastrService.error(response.message);
    }
  }

  getKindText(kindId: number): string {
    switch (kindId) {
      case 8:
        return 'Teklif';
      case 7:
        return 'Sipariş';
      case 5:
        return 'Alış';
      case 6:
        return 'Satış';
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  getStatusText(status: number, kindId: number): string {
    const kindText = this.getKindText(kindId);
    switch (status) {
      case 1:
        return `${kindText} Oluşturuldu`;
      case 2:
        return `${kindText} İptal Edildi`;
      case 3:
        return `${kindText} Onaylandı`;
      case 4:
        return `${kindText} Reddedildi`;
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }


  getStatusClass(status: number): string {
    switch (status) {
      case 1:
        return 'badge badge-info';    // Info class for status 1
      case 2:
        return 'badge badge-danger';  // Danger class for status 2
      case 3:
        return 'badge badge-success'; // Success class for status 3
      case 4:
        return 'badge badge-warning'; // Warning class for status 4
      default:
        return 'badge badge-secondary'; // Secondary class for unknown status
    }
  }


  isPrivateDiscountToogle() {
    this.isDiscount = !this.isDiscount;
  }

  calculateTotalAmount() {

    if (Array.isArray(this.transactionList)) {
      this.totalAmount = this.transactionList.reduce((acc, transaction) => {
        // Debugging line to check each transaction's total
        return acc + (transaction.total || 0);
      }, 0);
    } else {

      this.totalAmount = 0;
    }
  }


  sumCount(): number {
    return this.transactionList.reduce((total, transaction) => total + (transaction.productCount || 0), 0);
  }

  sumGross(): number {
    return this.transactionList.reduce((total, transaction) => total + (transaction.productPrice * transaction.productCount || 0), 0);
  }

  sumDiscount(): number {
    return this.transactionList.reduce((total, transaction) => total + (((transaction.productPrice * transaction.productCount) * transaction.discountRate) / 100 || 0), 0);
  }
  transactionDiscountTotal: any[];

  calculateTaxAndDiscountTotals(transactions) {
    if (!transactions || transactions.length === 0) {
      return [];
    }

    const totalsMap: { [taxId: number]: { taxRate: number, totalDiscount: number, totalTax: number } } = {};

    transactions.forEach(transaction => {
      const { taxId, taxRate, productPrice, productCount, discountRate } = transaction;

      const totalPrice = productPrice * productCount;
      const discountAmount = (totalPrice * discountRate) / 100;
      const priceAfterDiscount = totalPrice - discountAmount;
      const taxAmount = (priceAfterDiscount * taxRate) / 100;

      if (!totalsMap[taxId]) {
        totalsMap[taxId] = { taxRate, totalDiscount: 0, totalTax: 0 };
      }

      totalsMap[taxId].totalDiscount += discountAmount;
      totalsMap[taxId].totalTax += taxAmount;
    });

    this.transactionDiscountTotal = Object.keys(totalsMap).map(taxId => ({
      taxId: +taxId,
      taxRate: totalsMap[+taxId].taxRate,
      totalDiscount: totalsMap[+taxId].totalDiscount,
      totalTax: totalsMap[+taxId].totalTax
    }));

    console.log(this.transactionDiscountTotal);
    return this.transactionDiscountTotal;
  }
  sumNetTotal(): number {
    return this.transactionList.reduce((total, transaction) => {
      const totalPrice = transaction.productPrice * transaction.productCount;
      const discount = (totalPrice * transaction.discountRate) / 100;
      return total + (totalPrice - discount);
    }, 0);
  }

  calculateGeneralTotal(): number {
    return this.transactionList.reduce((total, transaction) => {
      const productPrice = transaction.productPrice || 0;
      const productCount = transaction.productCount || 0;
      const discountRate = transaction.discountRate || 0;
      const saleTax = transaction.saleTax || 0;
      const taxRate = transaction.taxRate || 0;

      const productTotalPrice = productPrice * productCount;
      const discount = (productTotalPrice * discountRate) / 100;
      const netPrice = productTotalPrice - discount;
      const vat = (netPrice * saleTax) / 100;
      const totalWithTaxRate = netPrice + vat + (netPrice * taxRate) / 100;

      return total + totalWithTaxRate;
    }, 0);
  }
}
